import React from 'react';

const TONES = {
  amber: 'border-amber-200 bg-amber-50 text-amber-900',
  red: 'border-red-200 bg-red-50 text-red-800',
  slate: 'border-slate-200 bg-slate-50 text-slate-600',
};

/** The verifier workspace's one inline notice (replaces three hand-rolled copies, audit M9). */
const VerifierNotice = ({ tone = 'amber', children, action = null, className = 'mb-4' }) => (
  <div
    role="status"
    className={`${className} flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 text-sm ${TONES[tone] ?? TONES.amber}`}
  >
    <span className="min-w-0 flex-1">{children}</span>
    {action}
  </div>
);

export default VerifierNotice;
